<template>
  <div class="footer" :style="footerStyle">
    <b-container class="bv-example-row mb-3">
      <b-row>
        <b-col class="pt-3 text-white">
          <h6>Холбоо барих</h6>
          Утас: <a class="text-white" href="tel:94116683">94116683</a>
        </b-col>
        <b-col class="pt-3 text-white text-right">
          <router-link class="text-white" to="/terms">
            Үйлчилгээний нөхцөл
          </router-link>
          <span class="footer-sep">·</span>
          <router-link class="text-white" to="/privacy">
            Нууцлалын бодлого
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerStyle: "",
    };
  },
  // mounted() {
  //   window.addEventListener("resize", this.listenResize);
  //   this.listenResize();
  // },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.listenResize);
  // },
  // methods: {
  //   listenResize() {
  //     const pageHeight = document.querySelector("#app").scrollHeight;
  //     const windowHeight = window.innerHeight;
  //     if (windowHeight > pageHeight + 100) {
  //       const diff = windowHeight - 100;
  //       this.footerStyle = "position:absolute; top:" + diff + "px";
  //     }
  //   },
  // },
  // updated() {
  //   const that = this;
  //   this.$nextTick(function () {
  //     that.listenResize();
  //   })
  // }
};
</script>

<style>
.footer {
  width: 100%;
  background-color: #22b353;
  height: 100px;
  font-family: "Roboto", sans-serif;
}
.footer-sep {
  margin: 0 8px;
  opacity: 0.6;
}
</style>
